import * as React from 'react';
import * as moment from 'moment';
import { withStyles, createStyles, Theme } from '@material-ui/core/styles';
import { withRouter, RouteComponentProps } from 'react-router';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import HashLink from '../Common/HashLink';

const jss = (theme: Theme) => createStyles({
    
});

interface Props extends RouteComponentProps {
    quizzes: Bee.Quiz[];
    classes: {

    };
}

class ScoresTable extends React.Component<Props, any> {
  	render() {
        // const { classes } = this.props;
        return (
            <Table>
                <TableHead>
                <TableRow>
                    <TableCell>Quiz Name</TableCell>
                    <TableCell>Quiz Status</TableCell>
                    <TableCell>Start Time</TableCell>
                    <TableCell>End Time</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {this.props.quizzes.map(row => {
                    return (
                    <TableRow key={row.id} hover>
                        <TableCell component="th" scope="row">
                            <HashLink to={`${this.props.match.path}/${row.id}`}>{row.title}</HashLink>
                        </TableCell>
                        <TableCell>{row.state}</TableCell>
                        <TableCell>{moment(row.startTime).format('MMMM Do YYYY, h:mm:ss a')}</TableCell>
                        <TableCell>{moment(row.endTime).format('MMMM Do YYYY, h:mm:ss a')}</TableCell>
                    </TableRow>
                    );
                })}
                </TableBody>
            </Table>
        );
	}
}

export default withRouter(withStyles(jss)(ScoresTable));



// WEBPACK FOOTER //
// ./src/components/Score/ScoresTable.tsx